// Use Bluebird as a Promise provider when the native implementation is not supported
if (typeof Promise !== "function") {
  window.Promise = require("bluebird");
}
